/*******************************************************************************
 * Copyright     : Copyright (c)  2021 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : rootReducer.ts
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Redux Root Reducer
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : December 16, 2021
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import { combineReducers } from "@reduxjs/toolkit";
import { authReducer } from "stores/AuthStore";
import { customerReducer } from "stores/CustomerStore";
import { generalInfoReducer } from "stores/GeneralInfoStore";
import { selectApmFileReducer } from "stores/SelectApmFileStore";
import { aircraftDetailsReducer } from "stores/AircraftDetailsStore";
import { apmFilesHistoryReducer } from "stores/ApmFilesHistoryStore";
import { apmSettingsReducer } from "stores/ApmSettingsStore";
import { uiReducer } from "stores/UIStore";
import { apmWorkFlowReducer } from "stores/ApmWorkFlowStore";

const rootReducer = combineReducers({
  ui: uiReducer,
  auth: authReducer,
  customer: customerReducer,
  generalInfo: generalInfoReducer,
  selectApmFile: selectApmFileReducer,
  aircraftDetails: aircraftDetailsReducer,
  apmFilesHistory: apmFilesHistoryReducer,
  apmSettings: apmSettingsReducer,
  apmWorkFlow: apmWorkFlowReducer,
});

export default rootReducer;
